export default "__VITE_ASSET__1gxTbiYC__"